import { OPERATOR_SUBROLE_TYPES } from './operatorRoles';

export const ADMINISTRATIVE_AGENT_ROLE_TYPE = 'agent_administratif';

function normalizePhaseName(name) {
  return String(name || '')
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '');
}

/**
 * Phase « Révision Initiale » du workflow conception (groupe 1, ordre 2).
 */
export function isInitialReviewPhase(phase) {
  if (!phase) return false;
  const group = String(phase.group ?? '');
  const order = phase.phase_order;
  if (group === '1' && order === 2) return true;
  const n = normalizePhaseName(phase.name);
  return n.includes('revision initiale');
}

/**
 * Rôles éligibles dans la modale « Assigner un opérateur » selon la phase.
 */
export function getAssignOperatorRoleTypesForPhase(phase) {
  if (isInitialReviewPhase(phase)) {
    return [ADMINISTRATIVE_AGENT_ROLE_TYPE];
  }
  return OPERATOR_SUBROLE_TYPES;
}

/**
 * Libellés de la modale d’assignation opérateur / agent administratif.
 */
export function getAssignOperatorModalCopy(phase) {
  if (isInitialReviewPhase(phase)) {
    return {
      title: 'Assigner un agent administratif',
      description:
        'Sélectionnez l’agent administratif pour la révision initiale de ce cas.',
    };
  }
  return {
    title: 'Assigner un opérateur',
    description: 'Sélectionnez l’opérateur à assigner à ce cas.',
  };
}

/** Jalon « Opérateur assigné » (ordre 1) en révision initiale. */
export function getOperatorAssignmentMilestone(phase) {
  if (!phase) return null;
  const list = phase.milestones ?? phase.items?.milestones ?? [];
  return list.find((m) => m.milestone_order === 1) ?? null;
}

/** Phase de révision pour laquelle un agent administratif peut être responsable. */
export function isAdministrativeAgentCasePhase(phase) {
  if (!phase) return false;
  if (isInitialReviewPhase(phase)) return true;
  const n = normalizePhaseName(phase.phase_name ?? phase.name);
  return n.includes('revision');
}

/**
 * IDs des conceptions assignées à l’agent (responsible_user_id sur phase révision).
 * @param {import('@supabase/supabase-js').SupabaseClient} supabaseClient
 * @param {string} userId
 */
export async function fetchAdministrativeAgentCaseIds(supabaseClient, userId) {
  if (!supabaseClient || !userId) return [];

  const { data, error } = await supabaseClient
    .from('case_timeline_phases')
    .select('case_id, group, phase_order, phase_name')
    .eq('responsible_user_id', userId);

  if (error) throw error;

  const ids = new Set();
  for (const phase of data || []) {
    if (phase?.case_id && isAdministrativeAgentCasePhase(phase)) {
      ids.add(phase.case_id);
    }
  }
  return [...ids];
}
